import { Shield, Award, CheckCircle } from "lucide-react";

const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      text: "SSL Secured"
    },
    {
      icon: Award,
      text: "Verified Business"
    },
    {
      icon: CheckCircle,
      text: "Trusted Partner"
    }
  ];

  return (
    <div className="flex flex-wrap gap-3 justify-center items-center">
      {badges.map((badge, index) => {
        const Icon = badge.icon;
        return (
          <div
            key={index}
            className="flex items-center gap-2 px-4 py-2 rounded-full border border-[hsl(var(--line))] glass-effect text-sm"
          >
            <Icon className="w-4 h-4 text-primary" />
            <span className="text-muted-foreground font-medium">{badge.text}</span>
          </div>
        );
      })}
    </div>
  );
};

export default TrustBadges;
